import { ChangeDetectionStrategy, Component, computed, HostBinding, inject, signal, Signal } from '@angular/core';
import { PlayerComponent as CorePlayerComponent } from 'player';
import { PlayerControlsComponent } from '../../components/player-controls/player-controls.component';
import { PlayerCompactControlsComponent } from '../../components/player-compact-controls/player-compact-controls.component';
import { PlayerTypes } from '../../data-access/player.config';
import { PlayerService } from '../../data-access/player.service';
import { PlayerHeaderComponent } from '../../components/player-header/player-header.component';
import { PlayerBingeComponent } from '../../components/player-binge/player-binge.component';
import { PlayerSkipIntroComponent } from '../../components/player-skip-intro/player-skip-intro.component';
import { PlayerSimilarContentComponent } from '../../components/player-similar-content/player-similar-content.component';

import { PlayerMessageComponent } from '../../components/player-message/player-message.component';
import { environment } from 'environments/environment';
import { PlayerEventsComponent } from '../../components/player-events/player-events.component';

@Component({
  selector: 'player',
  imports: [
    CorePlayerComponent,
    PlayerEventsComponent,
    PlayerControlsComponent,
    PlayerCompactControlsComponent,
    PlayerHeaderComponent,
    PlayerBingeComponent,
    PlayerSkipIntroComponent,
    PlayerSimilarContentComponent,
    PlayerMessageComponent
],
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlayerComponent {
  private playerService = inject(PlayerService);
  public targetId = signal<string>("video");
  public token = signal<string>(environment.operator.playerLicenseKey);
  public googleCastId = signal<string>(environment.operator.chromecastAppId);
  public castDebug = signal(environment.castDebug ?? null);
  public playerLayoutType: Signal<PlayerTypes> = this.playerService.getPlayerLayoutType();
  public similarContentItems: Signal<any[]> = this.playerService.getSimilarContentItems();
  public nextItem: Signal<any> = this.playerService.getNextItem();
  public isPip: Signal<boolean> = this.playerService.isPlayerPip();
  public isAdvertisingRunning = this.playerService.isAdvertisingRunning;
  public present = computed(() => {
    const obj = { controls: false, similarContent: false, header: false, message: false, binge: false, skipIntro: false, compactControls: false, events: true };
    switch (this.playerLayoutType()) {
      case PlayerTypes.MiniDetails:
        break;
      case PlayerTypes.Details:
        break;
      case PlayerTypes.Cover:
        break;
      case PlayerTypes.Mosaic:
        // Tiles auto-play on hover; suppress the play/pause status overlay.
        obj.events = false;
        break;
      case PlayerTypes.Normal:
        obj.controls = obj.header = obj.similarContent = true; obj.binge = true; obj.skipIntro = true; obj.message = true;
        break;
      case PlayerTypes.Pip:
        obj.header = true;
        break;
      case PlayerTypes.Audio:
      case PlayerTypes.Cast:
        obj.compactControls = true;
        break;
      default:
        break;
    }
    return obj;
  });

  @HostBinding('class.normal')
  public get isNormalPlayer(): boolean {
    return [PlayerTypes.Normal].includes(this.playerLayoutType()) && this.playerService.isPlayerInitialized();
  }

  @HostBinding('class.pip')
  public get isPipPlayer(): boolean {
    return this.playerLayoutType() === PlayerTypes.Pip;
  }

  @HostBinding('class.audio')
  public get isAudioPlayer(): boolean {
    return this.playerLayoutType() === PlayerTypes.Audio && this.playerService.isPlayerInitialized();
  }

  @HostBinding('class.cast')
  public get isCastPlayer(): boolean {
    return this.playerLayoutType() === PlayerTypes.Cast;
  }

  @HostBinding('class.none')
  public get isNonePlayer(): boolean {
    return this.playerLayoutType() === PlayerTypes.None;
  }

  // Inline trailer/extras previews: the hero on home and /videostore/catalogue
  // (Cover) and the details modal header (Details). The shared player view is
  // relocated into those hosts, so the layout type is what tells them apart.
  @HostBinding('class.trailer-preview')
  public get isTrailerPreview(): boolean {
    return [PlayerTypes.Cover, PlayerTypes.Details].includes(this.playerLayoutType());
  }

  ngOnInit() {
    console.log("HSX PLAYER INIT");
  }

  // castConfig: IPlayerCastConfig = {
  //   "contentId": "https://aviion-test.gcdn.co/testvodorigindash/sintel_original.json/manifest.mpd",
  //   "contentType": "svod",
  //   "customData": {
  //     "concurrencyType": "SVOD",
  //     "deviceId": "752fc84e-d3cd-4bf7-913a-3f0ed7ab122b",
  //     "merchant": "aviion",
  //     "posterUrl": "https://cloud-aviion-test-frontcdn.aviion.tv/3a60e2bcd4864f1dbda1b55f01105c6e.jpeg",
  //     "referenceId": "testdrm111",
  //     "sessionId": "SAKcXZhituGyB-500OKWvp1sEcX61AHC52IgIAO_XJC8TyI9mwkfxalIXkgQCkrFrGt5IcleKwE6INFfshkFKw..",
  //     "sessionPingInfo": {
  //       "customer": 279786,
  //       "device": "752fc84e-d3cd-4bf7-913a-3f0ed7ab122b",
  //       "operator": "novaplus",
  //       "pingInterval": "30000",
  //       "sessionId": "SAKcXZhituGyB-500OKWvp1sEcX61AHC52IgIAO_XJC8TyI9mwkfxalIXkgQCkrFrGt5IcleKwE6INFfshkFKw..",
  //       "url": "https://cloud-session-test.aviion.tv/ping"
  //     },
  //     "thumbnailDefinitionURL": "https://cloud-ottresources-test.aviion.tv/thumbnails/vod/testdrm111/thumbs.json",
  //     "type": "vod",
  //     "userId": 279786
  //   },
  //   "duration": 0,
  //   "metadata": {
  //     "images": [
  //       {
  //         "url": "https://cloud-aviion-test-frontcdn.aviion.tv/3a60e2bcd4864f1dbda1b55f01105c6e.jpeg"
  //       }
  //     ],
  //     "metadataType": 0,
  //     "title": "testdrm111",
  //     "type": 0
  //   },
  //   "streamType": "BUFFERED"
  // };

}
